export default {
  comingSoonTitle: 'COMING SOON',
  comingSoonTitleAlt: 'PRÓXIMAMENTE',
  comingSoonTaglineStart: 'AI-powered ',
  comingSoonTaglineHighlight: 'solutions',
  comingSoonTaglineEnd: ' to grow your business.',
  comingSoonCta: 'CONTACT US ON WHATSAPP',
  comingSoonLogoAlt: 'CHARVYS AI Business Solutions official logo',
  comingSoonModelAlt: 'CHARVYS businesswoman presenting artificial intelligence solutions',
  comingSoonModelTitle: 'CHARVYS - artificial intelligence solutions',
  comingSoonH1: 'CHARVYS - Coming Soon: AI-powered solutions',
  loaderLabel: 'Loading',
  langLabel: 'Language',
  langEs: 'ES',
  langEn: 'EN',
};